import ACTIONS, { FETCH_STATUS } from "../constants";

export const getCommunicationPlanAttempt = {
  pending: {
    type: ACTIONS.COMMUNICATION_PLAN.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.COMMUNICATION_PLAN.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.COMMUNICATION_PLAN.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getCommunicationPlan = (state) => ({
  type: ACTIONS.COMMUNICATION_PLAN_CALL,
  payload: state,
});

export const createCommunicationPlanAttempt = {
  pending: {
    type: ACTIONS.CREATE_COMMUNICATION_PLAN.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_COMMUNICATION_PLAN.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_COMMUNICATION_PLAN.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createCommunicationPlanRequest = (state) => ({
  type: ACTIONS.CREATE_COMMUNICATION_PLAN_CALL,
  payload: state,
});

export const updateCommunicationPlanAttempt = {
  pending: {
    type: ACTIONS.UPDATE_COMMUNICATION_PLAN.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_COMMUNICATION_PLAN.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_COMMUNICATION_PLAN.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateCommunicationPlanRequest = (state) => ({
  type: ACTIONS.UPDATE_COMMUNICATION_PLAN_CALL,
  payload: state,
});

export const deleteCommunicationPlanAttempt = {
  pending: {
    type: ACTIONS.DELETE_COMMUNICATION_PLAN.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_COMMUNICATION_PLAN.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_COMMUNICATION_PLAN.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteCommunicationPlanRequest = (state) => ({
  type: ACTIONS.DELETE_COMMUNICATION_PLAN_CALL,
  payload: state,
});

export const sortCommunicationPlansAttempt = {
  pending: {
    type: ACTIONS.SORT_COMMUNICATION_PLANS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_COMMUNICATION_PLANS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_COMMUNICATION_PLANS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortCommunicationPlansRequest = (state) => ({
  type: ACTIONS.SORT_COMMUNICATION_PLANS_CALL,
  payload: state,
});

export const updateCommunicationFlagAttempt = {
  pending: {
    type: ACTIONS.COMMUNICATION_PLAN_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.COMMUNICATION_PLAN_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.COMMUNICATION_PLAN_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateCommunicationFlag = (state) => ({
  type: ACTIONS.COMMUNICATION_PLAN_FLAG_CALL,
  payload: state,
});